import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
// import { components } from 'react-select'
// import { travelBrandsService } from '../../_services/TravelBrands.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

const gender = [
  {label: 'مرد', value: 0},
  {label: 'زن' , value: 1}
]

class GenderSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      defaultValue: ''
    };
  }

  handleChange = e =>{
    this.props.onChange(e.value);
  }

  render() {
    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        // height: 40,
        boxShadow: 'none',
        border: 'none',
        paddingRight: '12',
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading } = this.state;
    const { disabled } = this.props;

    return (
      <div>
        {!loading &&
          <Select
            isDisabled={disabled}
            placeholder="جنسیت"
            styles={customStyles}
            options={gender}
            onChange={this.handleChange}
            value={this.props.defaultValue}
            />
        }
      </div>
    );
  }
}
export default GenderSelect;
